import { render, staticRenderFns } from "./BringForwardIcon.vue?vue&type=template&id=a44d1b90&"
import script from "./BringForwardIcon.vue?vue&type=script&lang=js&"
export * from "./BringForwardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports